var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplayRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 15.833V6.998c0-1.425-1.71-2.121-2.692-1.108L23.275 17.892a1.568 1.568 0 000 2.248l12.002 12.002c1.013.981 2.723.285 2.723-1.14v-8.835c11.812 0 21.153 10.83 18.557 23.085-1.489 7.188-7.315 12.983-14.472 14.471C30.78 62.098 20.71 54.34 19.19 43.858c-.222-1.52-1.552-2.691-3.103-2.691-1.9 0-3.42 1.678-3.167 3.578a25.374 25.374 0 0030.178 21.28c9.88-1.932 17.829-9.88 19.76-19.76C65.993 30.02 53.643 15.833 38 15.833z",
    fill: "#4A4A4A"
  })));
}
export default __webpack_public_path__ + "static/media/ReplayRounded.4809af6e.svg";
export { SvgReplayRounded as ReactComponent };